<template>
    <div class="torso two-column alternate dense">
        <div class="container">
            <div class="wrap seismic-v2">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'seismic-layout'
    };
</script>
